import { requestGet, requestPost } from '@/common/request';

export default {
  // 品类类目
  async statisticTree(query) {
    return await requestGet('/statistic/tree', query);
  },

  // 跨品类关联-查询跨品类关联列表
  // https://cf.jd.com/pages/viewpage.action?pageId=1128440684
  async technicaCateRecList(query) {
    return await requestPost('/technicaCateRec/list', query);
  },

  // 跨品类关联-导出查询跨品类关联列表
  // https://cf.jd.com/pages/viewpage.action?pageId=1128440684
  async technicaCateRecExport(query) {
    return await requestPost('/technicaCateRec/export', query);
  },

  // 用户数据上报
  // https://cf.jd.com/pages/viewpage.action?pageId=1141230932
  // code = cross_category_card 【跨品类查询卡片】
  async commonServiceReportJson(query) {
    return await requestPost('/commonService/reportJson', query);
  },

  // 用户引导
  // https://cf.jd.com/pages/viewpage.action?pageId=385162767
  // key = kpl 【跨品类营销】
  async userGuide(query) {
    return await requestGet('/user/guide', query);
  },
};
